import React, { useRef, useId } from 'react'
import PropTypes from 'prop-types'

import * as s from './CodeInputs.module.scss'

const CodeInputs = ({ values, handleSubmit, handleChange, handlePaste }) => {
  const inputsRef = useRef([])

  const handleKeyDown = (event, i) => {
    if (event.key === 'Backspace' && event.target.value === '') {
      if (inputsRef.current[i - 1]) {
        inputsRef.current[i - 1].focus()
      }
    } else if (event.target.value.length === 1) {
      if (inputsRef.current[i + 1]) {
        inputsRef.current[i + 1].focus()
      }
    }
  }

  return (
    <div className={s.codes}>
      {values?.code?.map((value, i) => {
        const id = useId()
        const ref = (innerRef) => {
          inputsRef.current[i] = innerRef
        }
        return (
          <input
            key={id}
            type="text"
            name={`code[${i}]`}
            maxLength="1"
            className={s.input}
            ref={ref}
            onKeyDown={(event) => {
              handleKeyDown(event, i)
              if (event.key === 'Enter') {
                handleSubmit(event)
              }
            }}
            onChange={handleChange}
            value={value}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault()
              }
            }}
            onPaste={handlePaste}
          />
        )
      })}
    </div>
  )
}

export default CodeInputs

CodeInputs.defaultProps = {
  values: [],
  handleSubmit: () => {},
  handleChange: () => {},
  handlePaste: () => {},
}

CodeInputs.propTypes = {
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handlePaste: PropTypes.func,
}
